<template>
  <div>
    <h1 class="title">Настройки тестирования</h1>
    <form @submit.prevent="saveInterval" class="form">
      <label for="interval" class="label"
        >Интервал между попытками пройти тест в часах:</label
      >
      <div>
        <input type="number" id="interval" v-model="interval" class="input" />
        <button class="button" :disabled="disabled">Сохранить</button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Test',
  data() {
    return {
      interval: 0,
      disabled: false
    }
  },
  created() {
    this.getInterval()
  },
  methods: {
    async getInterval() {
      try {
        const { data } = await this.axios.get('/test/interval')
        if (data) {
          this.interval = data
        }
      } catch (e) {
        console.error(e)
      }
    },
    async saveInterval() {
      this.disabled = true
      try {
        await this.axios.post('/test/interval', { interval: this.interval })
        this.$toast.open({ message: 'Сохранено' })
      } catch (e) {
        this.$toast.open({ message: 'Ошибка' })
        console.error(e)
      } finally {
        this.disabled = false
      }
    }
  }
}
</script>

<style scoped>
.title {
  margin: 1rem;
  font-size: 1.6rem;
  text-align: center;
}
.form {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.input {
  width: 100px;
  display: inline-block;
}
.button {
  margin-left: 1rem;
}
</style>



// WEBPACK FOOTER //
// Index.vue?2625556e